import React, { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { Spin, Row, Col } from 'antd'
import { ProductListContext } from '../../contexts'
import ProductItem from './ProductItem'
import config from '../../config'

const ProductList = () => {
  const {
    fetchProductList,
    isLoading,
    productList
  } = useContext(ProductListContext)

  useEffect(() => {
    fetchProductList()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const _renderProductItem = (product) => {
    const isYourBirthStoryBook = product.name.includes('your-birth-story-book')
    const isSpecialUser = parseInt(config.userId) === 1

    return (!isYourBirthStoryBook || (isYourBirthStoryBook && isSpecialUser)) && (
        <Col span={8} key={product.name}>
          <ProductItem {...product} key={product.name} />
        </Col>
    )
  }

  return (
    <>
      {isLoading && (
        <div className="product-list-loading-container">
          <Spin />
        </div>
      )}
      <Row gutter={[16, 16]}>
        { productList.map(_renderProductItem)}
      </Row>
    </>
  )
}

ProductList.propTypes = {
  isLoading: PropTypes.bool,
  fetchProductList: PropTypes.func,
  productList: PropTypes.array
}

export default ProductList
